import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Pago, PagoDetalle } from '../../bussines/entities/Pago';
import { AbonosEstadoChip } from './AbonosEstadoChip';
import { formatFecha } from '../../utils/constans/formatFecha';
import AbonosDetalleTable from './AbonosDetalleTable';
import { useAbonosPasarela } from '../hooks/useAbonosPasarela';
import AbonoDetallesTotal from './AbonoDetallesTotal';

interface AbonoDetallesDialogProps {
   open: boolean,
   onClose: () => void,
   pago: Pago | null,
   loading: (isLoading: boolean) => void
}

const AbonoDetallesDialog: React.FC<AbonoDetallesDialogProps> = ({
   open,
   onClose,
   pago,
   loading
}) => {
   const [detalles, setDetalles] = useState<PagoDetalle[]>([])
   const { getDetallesAbono } = useAbonosPasarela();

   const fetchSomeAbonosPasarela = async () => {
      if (pago) {
         loading(true);
         const result = await getDetallesAbono({ idPago: pago.idPago });
         if (result) {
            setDetalles(result);
         }
         loading(false);
      }
   }

   useEffect(() => {
      fetchSomeAbonosPasarela();
   }, [pago])

   return (
      pago &&
      <Dialog open={open} maxWidth="md" PaperProps={{ sx: { p: 1 } }}>
         <DialogTitle>
            <Grid container spacing={1} justifyContent='space-between'>
               <Grid item>
                  <Typography variant="h4" component="span">
                     Detalles Documento {pago.documento}
                  </Typography>
               </Grid>
               <Grid item>
                  <AbonosEstadoChip estado={pago.estadoPago} />
               </Grid>
            </Grid>
         </DialogTitle>
         <DialogContent>
            <Grid item xs={12} container spacing={1}>
               <Grid item container xs={12} spacing={1} marginBottom={1}>
                  <Grid item xs={4}>
                     <Typography variant="body1" component="span">
                        {pago.docIdentidadCliente} - {pago.nombreRazonSocialCliente}
                     </Typography>
                  </Grid>
                  <Grid item xs={4}>
                     <Typography variant="body1" component="span">
                        Fecha Cobro: {formatFecha(pago.fechaCobro)}
                     </Typography>
                  </Grid>
                  <Grid item xs={4}>
                     <Typography variant="body1" component="span">
                        Fecha Pago: {formatFecha(pago.fechaPago)}
                     </Typography>
                  </Grid>
               </Grid>
               <Grid item xs={12}>
                  <AbonosDetalleTable
                     data={detalles}
                     fechaPeriodoDesde={pago.fechaPeriodoDesde}
                     fechaPeriodoHasta={pago.fechaPeriodoHasta}
                  />
                  <AbonoDetallesTotal montoDescuento={pago.montoCuponDescuento || 0} montoTotal={pago.monto} />
               </Grid>
            </Grid>
         </DialogContent>
         <DialogActions
            style={{ paddingInline: '24px', paddingBottom: '16px' }}
         >
            <Grid item xs={3}>
               <Button autoFocus onClick={onClose} fullWidth variant='contained'>
                  Cancelar
               </Button>
            </Grid>
         </DialogActions>
      </Dialog>
   );
};
export default AbonoDetallesDialog;
